import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              为什么选择木瓜影视
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              五大核心优势，打造极致追剧体验
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {featuresData.slice(0, 3).map((feature) => (
              <div
                key={feature.id}
                className="bg-background-100 rounded-lg border border-secondary-200/70 p-5 md:p-6 flex flex-col items-center text-center"
              >
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mb-4">
                  <i className={`${feature.icon} text-2xl`}></i>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                  {feature.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-4 md:mt-5 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {featuresData.slice(3, 5).map((feature) => (
              <div
                key={feature.id}
                className="bg-background-100 rounded-lg border border-secondary-200/70 p-5 md:p-6 flex flex-col items-center text-center"
              >
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mb-4">
                  <i className={`${feature.icon} text-2xl`}></i>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                  {feature.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}